<template>
  <div>
    <el-container style="height: 100vh; border: 1px solid #eee">
      <el-aside
        width="200px"
        style="background-color: rgb(238, 241, 246); height: 100vh"
      >
        <el-menu :default-openeds="['1']" style="height: inherit" router>
          <el-submenu index="1">
            <template slot="title"
              ><i class="el-icon-message"></i>首页</template
            >
            <el-menu-item-group>
              <el-menu-item index="/editBanner">轮播图</el-menu-item>
              <el-menu-item index="/contentShow">内容展示</el-menu-item>
              <el-menu-item index="/editTree">树形内容</el-menu-item>
              <el-menu-item index="/editNews">新闻编辑</el-menu-item>
              <el-menu-item index="/editSeo">SEO设置</el-menu-item>
            </el-menu-item-group>
          </el-submenu>
          <el-submenu index="2">
            <template slot="title"><i class="el-icon-menu"></i>微信消息通知设置</template>
            <el-menu-item-group>
              <el-menu-item index="/wxNewsMessage">新闻消息</el-menu-item>
            </el-menu-item-group>
          </el-submenu>
        </el-menu>
      </el-aside>

      <el-container>
        <el-header style="text-align: right; font-size: 12px"> </el-header>

        <el-main>
          <router-view />
        </el-main>
      </el-container>
    </el-container>
  </div>
</template>

<script>
export default {
  name: 'Edit',
  data() {
    const item = {
      date: '2016-05-02',
      name: '王小虎',
      address: '上海市普陀区金沙江路 1518 弄'
    }
    return {
      tableData: Array(20).fill(item)
    }
  }
}
</script>

<style scoped>
.el-header {
  background-color: #b3c0d1;
  color: #333;
  line-height: 60px;
}

.el-aside {
  color: #333;
}
</style>
